import { render, staticRenderFns } from "./results-total.vue?vue&type=template&id=1af68aac&scoped=true"
import script from "./results-total.vue?vue&type=script&lang=js"
export * from "./results-total.vue?vue&type=script&lang=js"
import style0 from "./results-total.vue?vue&type=style&index=0&id=1af68aac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af68aac",
  null
  
)

export default component.exports